<template>

  <!-- Event Details Content -->
  <div
    v-if="value"
    class="event-details-content">

    <div
      class="event-details-content__row">

      <div
        v-if="value.startDate">

        <div
          class="event-details-content__label">
          дата проведения
        </div>

        <div
          class="event-details-content__value">
          {{ date }}
          <br/>
          {{ time }}
        </div>

      </div>

      <div
        v-if="value.eventType">

        <div
          class="event-details-content__label">
          тип мероприятия
        </div>

        <div
          class="event-details-content__value">
          {{ $u.localize(value.eventType.title) }}
        </div>

      </div>

      <!--
      <div>

        <div
          class="event-details-content__label">
          стоимость участия
        </div>

        <div
          class="event-details-content__value">
          {{ value.cost || 'бесплатно' }}
        </div>

      </div>
      -->

      <div>

        <div
          class="event-details-content__label">
          место проведения
        </div>

        <div
          class="event-details-content__value">
          {{ value.place || 'онлайн' }}
        </div>

      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'event-details-content',
    props: {
      value: {
        type: Object,
        default: null,
      },
    },
    computed: {
      date() {

        return this.$date.humanDate({
          first: this.value.startDate,
          second: this.value.endDate,
          local: true,
        });
      },
      time() {

        return this.$date.humanDate({
          first: this.value.startDate,
          second: this.value.endDate,
          timeOnly: true,
          local: true,
        });
      },
    },
  };

</script>

<style lang="scss">

  $gap-y: 2rem;
  $gap-x: .5rem;

  .event-details-content {
    color: inherit;

    &__row {
      display: flex;
      flex-wrap: wrap;
      margin-top: -$gap-y;
      margin-left: -$gap-x;
      justify-content: center;
    }

    &__row > div {
      width: 270px;
      padding-top: $gap-y;
      padding-left: $gap-x;
    }

    &__label {
      font-size: 1rem;
      margin-top: -.3rem;
    }

    &__value {
      font-weight: 600;
      font-size: 1.3rem;
      margin-top: $spacer-xs;
    }
  }

</style>
